var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[_vm.compact ? 'caption' : 'body-2', 'font-weight-regular'],style:({ color: _vm.configuracao.cor })},[_vm._v(" "+_vm._s(_vm.configuracao.rotulo)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }